import LocationListContainer from './LocationListContainer';

export default LocationListContainer;
